export function triggerContentUpdated(selectorOrEl) {
    const $ = window.jQuery;
    if (!$) return;

    const $el = typeof selectorOrEl === 'string' ? $(selectorOrEl) : $(selectorOrEl);
    $el.trigger('contentUpdated');
}
